import * as React from "react";
import ConnectedFormControl from "../../FormControl/FormControl/FormControl.js";
import { isText } from "../../Util/Util/validations.js";
const LastName = ({
  label,
  errorMessage,
  validations = [isText],
  ...rest
}) => /* @__PURE__ */ React.createElement(
  ConnectedFormControl,
  {
    ...ConnectedFormControl.defaultProps,
    id: "lastName",
    "data-t": "last-name",
    label,
    errorMessage,
    validations,
    ...rest
  }
);
export {
  LastName as default
};
//# sourceMappingURL=LastName.js.map
